import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { B2bConfiguratorContainerComponent } from './b2b-configurator-container/b2b-configurator-container.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild([
            {
                path: 'configure/complex/:complexConfiguratorId/:productId/:categoryId/:salesDocumentId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'add'
                }
            },
            {
                path: 'configure/complex/:complexConfiguratorId/:productId/:categoryId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'add'
                }
            },
            {
                path: 'configure/complex/:complexConfiguratorId/:productId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'add'
                }
            },
            {
                path: 'configure/complex/:complexConfiguratorId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'add'
                }
            },
            {
                path: 'edit/:positionId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'edit'
                }
            },
            {
                path: 'edit/:positionId/:productId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'edit'
                }
            },
            {
                path: 'edit/:positionId/:productId/:salesDocumentId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'edit'
                }
            },
            {
                path: 'copy/:positionId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy'
                }
            },
            {
                path: 'copy/:positionId/:productId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy'
                }
            },
            {
                path: 'copy/:positionId/:productId/:salesDocumentId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy'
                }
            },
            {
                path: 'copy-spare/:positionId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy-spare'
                }
            },
            {
                path: 'copy-spare/:positionId/:productId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy-spare'
                }
            },
            {
                path: 'copy-spare/:positionId/:productId/:salesDocumentId',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'copy-spare'
                }
            },
            {
                path: 'configure/:type',
                component: B2bConfiguratorContainerComponent,
                data: {
                    action: 'add'
                }
            },
        ]),
    ],
    declarations: [B2bConfiguratorContainerComponent],
    exports: [B2bConfiguratorContainerComponent],
    providers: []
})
export class B2BConfiguratorLoaderModule {}
